(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovelra-beauty-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-ov-filter]');
  if (!button) return;
  const root = button.closest('.ov-shop');
  root.querySelectorAll('[data-ov-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  root.querySelectorAll('[data-ov-category]').forEach(card => card.hidden = button.dataset.ovFilter !== 'all' && card.dataset.ovCategory !== button.dataset.ovFilter);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovelra-oil-product-main"]) return;
  try {
    
document.addEventListener('click', function(event) {
 const root = event.target.closest('[data-ov-product]'); if (!root) return;
 const help = event.target.closest('a[href="#ov-product-help"]'); if (help) { const faq = document.querySelector('[id^="store-faq-"]'); if (faq) { event.preventDefault(); faq.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'}); } }
 const photo = event.target.closest('[data-ov-image]');
 if (photo) { const main = root.querySelector('.ov-selected-image'); main.removeAttribute('srcset'); main.src = photo.dataset.ovImage; main.alt = photo.dataset.ovAlt; root.querySelectorAll('[data-ov-image]').forEach(b => b.setAttribute('aria-pressed', String(b === photo))); }
 const step = event.target.closest('[data-ov-quantity]');
 if (step) { const input = root.querySelector('[name="quantity"]'); input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.ovQuantity)); input.dispatchEvent(new Event('change', {bubbles:true})); }
});
document.addEventListener('change', function(event) {
 const variant = event.target.closest('[data-ov-variant]'); if (!variant) return;
 const root = variant.closest('[data-ov-product]'); root.querySelector('[data-ov-price]').textContent = variant.dataset.price;
 if (variant.dataset.image) { const main = root.querySelector('.ov-selected-image'); main.removeAttribute('srcset'); main.src = variant.dataset.image; main.alt = variant.dataset.imageAlt; root.querySelectorAll('[data-ov-image]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.ovImage === variant.dataset.image))); }
 const compare = root.querySelector('[data-ov-compare]'); compare.textContent = variant.dataset.compare; compare.hidden = !variant.dataset.compare;
 const buy = root.querySelector('[data-ov-buy]'); buy.disabled = variant.dataset.available !== 'true'; buy.textContent = buy.disabled ? buy.dataset.soldLabel : buy.dataset.addLabel;
 const status = root.querySelector('[data-ov-status]'); status.dataset.unavailable = String(buy.disabled); root.querySelector('[data-ov-stock-label]').textContent = buy.disabled ? status.dataset.soldLabel : (variant.dataset.stock === 'true' ? status.dataset.stockLabel : status.dataset.orderLabel);
 const sticky = root.querySelector('[data-ov-sticky-price]'); if (sticky) sticky.textContent = variant.dataset.price;
 const url = new URL(window.location.href); url.searchParams.set('variant', variant.value); window.history.replaceState({}, '', url);
});
const ovBuyObserver = new IntersectionObserver(entries => entries.forEach(entry => { const bar=entry.target.closest('[data-ov-product]').querySelector('.ov-sticky-shop');if(bar)bar.classList.toggle('is-hidden',entry.isIntersecting);}),{threshold:0});document.querySelectorAll('[data-ov-buy]').forEach(button=>ovBuyObserver.observe(button));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovelra-product-main"]) return;
  try {
    
document.addEventListener('click', function(event) {
 const root = event.target.closest('[data-ov-product]'); if (!root) return;
 const help = event.target.closest('a[href="#ov-product-help"]'); if (help) { const faq = document.querySelector('[id^="store-faq-"]'); if (faq) { event.preventDefault(); faq.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'}); } }
 const photo = event.target.closest('[data-ov-image]');
 if (photo) { const main = root.querySelector('.ov-selected-image'); main.removeAttribute('srcset'); main.src = photo.dataset.ovImage; main.alt = photo.dataset.ovAlt; root.querySelectorAll('[data-ov-image]').forEach(b => b.setAttribute('aria-pressed', String(b === photo))); }
 const step = event.target.closest('[data-ov-quantity]');
 if (step) { const input = root.querySelector('[name="quantity"]'); input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.ovQuantity)); input.dispatchEvent(new Event('change', {bubbles:true})); }
});
document.addEventListener('change', function(event) {
 const variant = event.target.closest('[data-ov-variant]'); if (!variant) return;
 const root = variant.closest('[data-ov-product]'); root.querySelector('[data-ov-price]').textContent = variant.dataset.price;
 if (variant.dataset.image) { const main = root.querySelector('.ov-selected-image'); main.removeAttribute('srcset'); main.src = variant.dataset.image; main.alt = variant.dataset.imageAlt; root.querySelectorAll('[data-ov-image]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.ovImage === variant.dataset.image))); }
 const compare = root.querySelector('[data-ov-compare]'); compare.textContent = variant.dataset.compare; compare.hidden = !variant.dataset.compare;
 const buy = root.querySelector('[data-ov-buy]'); buy.disabled = variant.dataset.available !== 'true'; buy.textContent = buy.disabled ? buy.dataset.soldLabel : buy.dataset.addLabel;
 const status = root.querySelector('[data-ov-status]'); status.dataset.unavailable = String(buy.disabled); root.querySelector('[data-ov-stock-label]').textContent = buy.disabled ? status.dataset.soldLabel : (variant.dataset.stock === 'true' ? status.dataset.stockLabel : status.dataset.orderLabel);
 const sticky = root.querySelector('[data-ov-sticky-price]'); if (sticky) sticky.textContent = variant.dataset.price;
 const url = new URL(window.location.href); url.searchParams.set('variant', variant.value); window.history.replaceState({}, '', url);
});
const ovBuyObserver = new IntersectionObserver(entries => entries.forEach(entry => { const bar=entry.target.closest('[data-ov-product]').querySelector('.ov-sticky-shop');if(bar)bar.classList.toggle('is-hidden',entry.isIntersecting);}),{threshold:0});document.querySelectorAll('[data-ov-buy]').forEach(button=>ovBuyObserver.observe(button));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovelra-ritual-details"] && !Shopify.designMode) return;
  try {
    
(function(){
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new WeakMap();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const el = entry.target, state = states.get(el);
      if (!state) return;
      if (!entry.isIntersecting) {
        cancelAnimationFrame(state.frame);
        state.active = false;
        el.textContent = state.original;
        return;
      }
      if (entry.intersectionRatio < 0.5 || state.active) return;
      state.active = true;
      if (motion.matches) { el.textContent = state.original; return; }
      const start = performance.now();
      const format = value => state.prefix + (state.grouped
        ? value.toLocaleString('en-US', {minimumFractionDigits:state.decimals,maximumFractionDigits:state.decimals})
        : value.toFixed(state.decimals)) + state.suffix;
      el.textContent = format(0);
      function frame(now) {
        if (!el.isConnected || !state.active) return;
        const progress = Math.min((now-start)/1100,1);
        el.textContent = progress === 1 ? state.original : format(state.value*(1-Math.pow(1-progress,3)));
        if (progress < 1) state.frame = requestAnimationFrame(frame);
      }
      state.frame = requestAnimationFrame(frame);
    });
  }, {threshold:[0,0.5]});
  function init(root) {
    root.querySelectorAll('[data-ov-count], [data-ov-count-text]').forEach(el => {
      if (states.has(el)) return;
      const original = el.dataset.ovCountText !== undefined ? el.dataset.ovCountText : el.dataset.ovCount;
      const match = original.match(/^(\s*[^\d]*?)(-?\d[\d,]*(?:\.\d+)?)([^\d]*)$/);
      if (!match) return;
      const value = Number(match[2].replace(/,/g,''));
      if (!Number.isFinite(value)) return;
      states.set(el,{original,value,prefix:match[1],suffix:match[3],decimals:(match[2].split('.')[1]||'').length,grouped:match[2].includes(','),active:false,frame:0});
      observer.observe(el);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-ov-count], [data-ov-count-text]').forEach(el => {
      const state=states.get(el);
      if (state) cancelAnimationFrame(state.frame);
      observer.unobserve(el);
      states.delete(el);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
